module.exports = __webpack_public_path__ + "img/fundlist-background.dcc350b4.png";